import React from "react";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu.tsx";
import { EllipsisVerticalIcon } from "lucide-react";
import { deleteItems } from "@/api/offline.ts";
import { deleteStateEntry, itemsState, uiState } from "@/states.ts";
import { processQueue } from "@/api/queue.ts";
import { useSnapshot } from "valtio/react";

import { useCurrentList } from "@/hooks/lists.ts";

const EditListMenu: React.FC = (props) => {
	const itemsSnap = useSnapshot(itemsState);
	const list = useCurrentList(false);

	const handleEdit = () => {
		if (!list) return;
		uiState.editingList = list;
	};

	const handleShare = () => {
		if (!list) return;
		uiState.sharingList = list;
	};

	const handleClear = () => {
		const listId = list?.id;
		if (!listId) return;

		const completedItemIds = Object.values(itemsSnap.items[listId]).filter(
			(i) => !!i.completed,
		);

		deleteItems(listId, completedItemIds).then((l) => {
			for (const item of completedItemIds) {
				deleteStateEntry(itemsState.items, listId, item);
			}
		});
		processQueue();
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger>
				<EllipsisVerticalIcon />
			</DropdownMenuTrigger>
			<DropdownMenuContent>
				<DropdownMenuItem onClick={handleEdit}>Edit List</DropdownMenuItem>
				<DropdownMenuItem onClick={handleShare}>
					Share List
				</DropdownMenuItem>
				<DropdownMenuItem onClick={handleClear}>
					Clear Complete
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export { EditListMenu };
